<app-header-simple [hideCloseIcon]="true"></app-header-simple>

<div class="page-container">
  <div class="nosidebar-container">
    <div class="flex flex-col flex-center mt-16 sm:mt-4">
      <app-access-restricted></app-access-restricted>
    </div>
  </div>
</div>

